import { graphql } from "gatsby";
import { Campaign } from "./Campaign";
import { omit } from "ramda";
export default Campaign;

export const query = graphql`
  query Campaign($id: HASURA_uuid!) {
    hasura {
      campaigns_by_pk(id: $id) {
        id
        slug
        name
        content
        custom_copy
        segmentation
        configuration
        university {
          name
          slug
          logo_url
          configuration
          content
          stylesheets_universities {
            stylesheet {
              id
              body
            }
          }
        }
        target_regions {
          id
          name
          configuration
        }
      }
    }
  }
`;

export const Head = ({ pageContext }) => {
  const assets = pageContext.assets;
  if (!assets.length) return null;

  return (
    <>
      {assets.map((asset, index) => {
        const keys = asset.properties.map((property) => property.key);
        const properties = asset.properties.reduce(
          (acc, property) => ({
            ...acc,
            [property.key]: property.value,
          }),
          {},
        );

        if (asset.type === "script") {
          const propsWithoutBody = omit(properties, "body");
          return keys.includes("body") ? (
            <script key={index} {...propsWithoutBody}>
              {properties["body"]}
            </script>
          ) : (
            <script key={index} {...properties} />
          );
        }
        if (asset.type === "link") {
          return <link key={index} {...properties} />;
        }
        return null;
      })}
    </>
  );
};
